module.exports = __webpack_public_path__ + "img/background008.jpg";